import { useState } from "react";
import type { UserInfoType } from "@app/hooks/useUserInfo";
import {
  mySPHOpenLogout,
  mySPHOpenResendVerificationMail,
  mySPHOpenUpdatePassword,
} from "@app/util/helpers";
import Icon from "@components/Icon/Icon";
import cx from "classnames";

import styles from "./UserInfo.module.scss";

export type UserInfoProps = {
  rootClassName?: string;
  userInfo: UserInfoType;
};

/**
 *
 * @param rootClassName top-level css class override
 * @param userInfo user data decoded from JWT
 * @see https://docs.google.com/document/d/1obM9zIuU0Cj6UlI3mkHXGWDEIAGpCx029iiuV_kEwUU/edit# for API usage of window._mySPHObj
 */
export default function UserInfo({
  rootClassName,
  userInfo,
}: UserInfoProps): React.ReactElement {
  const [isPanelVisible, setIsPanelVisible] = useState<boolean>(false);

  return (
    <div className={cx(styles.userInfo, rootClassName)}>
      <div
        className={cx(
          styles.navRoot,
          "flex flex-row items-center justify-center"
        )}
        onClick={() => {
          setIsPanelVisible(!isPanelVisible);
        }}
      >
        <Icon type="user" />
        <div className="ml-[4px] max-w-[200px] truncate font-normal max-lg:hidden">
          {userInfo?.lastname}
        </div>
        <Icon type="chevronDown" rootClassName={styles.iconArrowDown} />
      </div>

      {isPanelVisible ? (
        <ul className={styles.userInfoPanel}>
          <li>
            Welcome
            <div className="font-normal">{userInfo?.lastname}</div>
          </li>
          <li>
            <a
              target="_blank"
              href={`https://subscribe.sph.com.sg/your-account/?utm_campaign=manageaccount&utm_medium=sph-publication&utm_source=bt&utm_content=manageaccountlink-dropdown&pub-code=bt${encodeURIComponent(
                location.href
              )}`}
              rel="noreferrer"
            >
              Manage Account
            </a>
          </li>
          {userInfo ? (
            <span id="sph_user_name" className="hidden">
              {encodeURI(userInfo.loginId)}
            </span>
          ) : null}
          {userInfo?.sub === "unverified" ? (
            <li onClick={mySPHOpenResendVerificationMail}>
              <span className="font-poppins text-red">
                <strong>Please verify your email</strong>
              </span>
            </li>
          ) : null}
          <li onClick={mySPHOpenUpdatePassword}>Update your password</li>
          <li onClick={mySPHOpenLogout}>Logout</li>
        </ul>
      ) : null}
    </div>
  );
}
